import React from 'react'
import './404.css'

const NotFoundText = () => {
    return (
        <div className="not-found-text">
            <h1 className="not-found-big-text">
                404
            </h1>
            <p classsName="not-found-small-sub-text">
                The page you are looking for is not available
            </p>
        </div>
    )
}

export default NotFoundText
